module.exports = __webpack_public_path__ + "img/banner-3.9866ff2d.jpg";